import { Position } from '@models/position';
import { PositionCreationMode, PositionInspector } from '@core/models';

export class CustomPositionInspector extends PositionInspector {
  constructor(positions: Position[]) {
    super(positions);
  }

  detectOpenPosition(): Position {
    return (
      this.findRichiestaFidoOpen() ||
      this.findUtilizzoFidoOpen() ||
      this.findRichiestaFidoCompleted()
    );
  }

  detectCreationMode(): PositionCreationMode {
    if (!!this.findRichiestaFidoCompleted() && !this.findUtilizzoFidoOpen()) {
      return PositionCreationMode.utilizzoFido;
    } else if (
      !this.findRichiestaFidoOpen() &&
      !this.findRichiestaFidoCompleted()
    ) {
      return PositionCreationMode.richiestaFido;
    } else {
      return null;
    }
  }

  /**
   * restituisce la prima position di richiesta fido che risulta aperta e non completata
   */
  private findRichiestaFidoOpen(): Position {
    return this.find(
      x =>
        x.isCqsRf() &&
        x.isOpen() &&
        !x.hasStatus('FIDO-OK') &&
        !x.hasPhase('300')
    );
  }

  /**
   * restituisce la prima position di richiesta fido che risulta completata
   */
  private findRichiestaFidoCompleted(): Position {
    return this.find(
      x => x.isCqsRf() && x.hasStatus('FIDO-OK') && x.hasPhase('300')
    );
  }

  /**
   * restituisce la prima position di utilizzo fido che risulta aperta e non completata
   */
  private findUtilizzoFidoOpen(): Position {
    return this.find(
      x =>
        x.isCqsUf() &&
        x.isOpen() &&
        !x.hasStatus('LIQ-POS') &&
        !x.hasPhase('400')
    );
  }

  /**
   * restituisce la prima position di utilizzo fido che risulta aperta e non completata
   */
  private findUtilizzoFidoCompleted(): Position {
    return this.find(
      x => x.isCqsUf() && x.hasStatus('LIQ-POS') && x.hasPhase('400')
    );
  }
}
